<template>
  <div class="experience-header">
    <div>
      <div class="header-text">{{ type === 'STORE' ? '매장 체험단' : '제품 체험단' }}</div>
      <div class="header-text-sub">
        {{
          type === 'STORE'
            ? '블로거가 직접 매장에 방문하고 리뷰하는 체험단'
            : '블로거가 제품을 받아 사용해보며 리뷰하는 체험단'
        }}
      </div>
    </div>

    <div class="header-icon">
      <img
        :src="require(`@/assets/img/lead-modal/${type === 'STORE' ? 'store_logo' : 'product_logo'}.png`)"
        :alt="type === 'STORE' ? '매장 체험단' : '제품 체험단'"
        :class="type === 'STORE' ? 'store-icon' : 'product-icon'" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeadExperienceHeader',

  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['STORE', 'PRODUCT'].includes(value),
    },
  },
};
</script>

<style scoped lang="scss">
.experience-header {
  display: flex;
  height: 76px;
  padding: 8px 16px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: var(--inversed_dark, #fbfbfb);
  justify-content: space-between;

  .header-text {
    font-family: 'Spoqa Han Sans Neo';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    background: var(--inversed_dark, #fbfbfb);
    color: var(--default, #3a3a3a) !important;
  }

  .header-text-sub {
    color: var(--default, #3a3a3a);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
  }

  .header-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    img {
      width: 56px;
      height: 56px;
      object-fit: contain;

      &.store-icon {
        width: 56px;
        height: 56px;
      }

      &.product-icon {
        width: 56px;
        height: 56px;
      }
    }
  }
}
</style>
